import { useMemo, useState } from 'react';

import { Payout } from 'store/api/payout';
import { Gallery } from 'components/gallery';
import { FileType, PayoutStatus } from 'types';
import { Image, openReceipt } from 'components/image';
import { PaymentDetails } from 'components/payment-details';

import { ReimbursementDetailsProps } from './types';

const getExtendsRows = (data?: Payout) => {
  const result = [
    {
      col: 3,
      colTablet: 6,
      title: 'Category',
      value: data?.category?.name,
    },
  ];

  if (data?.status === PayoutStatus.PartialApproved) {
    result.push({
      col: 3,
      colTablet: 6,
      title: 'Request Amount',
      value: data?.requestAmount?.toString(),
    });
  }

  return result;
};

export const ReimbursementDetails = ({
  data,
  title,
  disableSticky,
  ...props
}: ReimbursementDetailsProps) => {
  const [isOpen, setOpen] = useState(false);

  const extendsRows = useMemo(() => getExtendsRows(data), [data]);

  return (
    <PaymentDetails
      data={data}
      extendsRows={extendsRows}
      disableSticky={disableSticky}
      title={title || 'Reimbursement'}
      {...props}
      extendsSections={{
        col: 6,
        title: 'Receipt',
        value: (
          <Image
            width={144}
            height={144}
            objectFit="cover"
            alt="Receipt photo"
            src={data?.receiptUrl}
            onClick={() => openReceipt(data?.receiptUrl, () => setOpen(true))}
          />
        ),
      }}
    >
      {data?.receiptUrl && (
        <Gallery
          open={isOpen}
          hideFooterButton
          close={() => setOpen(false)}
          files={[
            {
              id: 1,
              url: data.receiptUrl,
              type: FileType.Image,
              name: 'Receipt photo',
            },
          ]}
        />
      )}
    </PaymentDetails>
  );
};
